export default __webpack_public_path__ + "static/media/CardHamam2.24f6803a.jpg";